import { render, staticRenderFns } from "./OwnerCalculationTable.vue?vue&type=template&id=c7a0a128&scoped=true&"
import script from "./OwnerCalculationTable.vue?vue&type=script&lang=js&"
export * from "./OwnerCalculationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a0a128",
  null
  
)

export default component.exports